import type {Theme, Components} from "../..";

type FormControlLabelOverrides = Components<Theme>["MuiFormControlLabel"];

const overrides: FormControlLabelOverrides = {
    styleOverrides: {
        label: ({theme}) => ({
            color: theme.color.text.default,
        }),
    },
};

export default overrides;
